module.exports = __webpack_public_path__ + "static/media/CTLA_6-216w.63a35d84.jpg";